import { requiredOptionsToInjectMask, requiredOptionsToRunMask } from './consts';
import Mask from './Mask';
import Pending from './Pending';
import ScriptInjector from './ScriptInjector';
import ScriptUrl from './ScriptUrl';
class CSI {
    _ProjectName;
    _Stand;
    _Injector = new ScriptInjector();
    _currentInjectionMask = Mask.createFrom([]);
    _currentRunMask = Mask.createFrom([]);
    _username;
    _hasRuned = false;
    _pendingToInject = new Pending(Mask.createFrom([
        requiredOptionsToInjectMask.projectName,
        requiredOptionsToInjectMask.stand,
    ]), this._currentInjectionMask);
    _pendingToRun = new Pending(Mask.createFrom([requiredOptionsToRunMask.scriptIncluded]), this._currentRunMask);
    constructor(options) {
        this.setProjectName(options?.projectName);
        this.setStand(options?.stand);
        this._init();
    }
    _init() {
        this._pendingToInject.on('ready', this._injectScript);
        this._Injector.on('load', this._onInjected);
    }
    _injectScript = () => {
        this._pendingToInject.off('ready', this._injectScript);
        this._Injector.setUrl(new ScriptUrl(this._Stand));
        this._Injector.inject();
    };
    _onInjected = () => {
        this._Injector.off('load', this._onInjected);
        this._currentRunMask.merge(requiredOptionsToRunMask.scriptIncluded);
    };
    _isReadyToRun() {
        return this._pendingToRun.isReady(this._currentRunMask);
    }
    _delayedRun = () => {
        this._pendingToRun.off('ready', this._delayedRun);
        this.run(this._username);
        this._username = undefined;
    };
    setProjectName(projectName) {
        if (!projectName?.length)
            return;
        this._ProjectName = projectName;
        this._currentInjectionMask.merge(requiredOptionsToInjectMask.projectName);
    }
    setStand(stand) {
        if (!stand?.length)
            return;
        this._Stand = stand;
        this._currentInjectionMask.merge(requiredOptionsToInjectMask.stand);
    }
    run = (username, trigger = 'start') => {
        if (!username || this._hasRuned)
            return;
        if (!this._isReadyToRun() && username?.length) {
            this._username = username;
            return this._pendingToRun.on('ready', this._delayedRun);
        }
        this._hasRuned = true;
        window.sfb.run(this._ProjectName, username, trigger);
    };
}
export default new CSI();
